<template>
  <span v-if="rent_amount_type === 'range'">
    {{ withTtc ? $t('ui.rentDisplay.rent') : '' }} {{ $t('ui.rentDisplay.fromC') }}
    <span :class="{ colored: withColor, bold: withBold }">
      {{ offer.offer_pricing.rent_amount_from }} {{$t('ui.rentDisplay.to')}} {{ offer.offer_pricing.rent_amount_to }}{{ withPerMonth ? $t('ui.rentDisplay.perMonth') : ''}}
    </span>
  </span>
  <span v-else-if="rent_amount_type === 'from'">
    {{ withTtc ? $t('ui.rentDisplay.rentFrom') : $t('ui.rentDisplay.rentFromB') }} {{$t('ui.rentDisplay.from')}}
    <span :class="{ colored: withColor, bold: withBold }">
      {{ offer.offer_pricing.rent_amount_from }}{{ withPerMonth ? $t('ui.rentDisplay.perMonth') : ''}}
    </span>
  </span>
  <span v-else-if="rent_amount_type === 'unique'">
    {{ withTtc ? $t('ui.rentDisplay.rentExact') : '' }}
    <span :class="{ colored: withColor, bold: withBold }">
      {{ offer.offer_pricing.rent_amount_from }}{{ withPerMonth ? $t('ui.rentDisplay.perMonth') : '' }}
    </span>
  </span>
</template>

<script>
export default {
  name: "RentDisplay",
  props: {
    offer: {
      type: Object,
      required: true
    },
    withTtc: {
      type: Boolean,
      default: false
    },
    withPerMonth: {
      type: Boolean,
      default: false
    },
    withColor: {
      type: Boolean,
      default: false
    },
    withBold: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rent_amount_type() {
      return this.offer.offer_pricing.rent_amount_type
    }
  }
}
</script>

<style lang="scss" scoped>
span {
  .colored {
    color: $--color-primary !important;
  }
  .bold {
    font-weight: 700;
  }
}
</style>